<template>
  <div id="TarifKarbaran">
    <Card  add back tools toolsColumns>
    <template v-slot:header>
      <h4 class="d-inline">لیـستـ کــاربـران</h4>
      <hr>    
    </template>
    <template v-slot:content>
      <!-- <Grid  :IsInformation="false"></Grid> -->
      <grid :IsInformation="false"></grid>

        
    </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import Grid from '../Public/Grid.vue';
export default {
  components: {
    Card,
    Grid,
},
  data() {
    return {

    };
  },

  
};
</script>
<style scoped></style>